const selectorsHoverItem = {
  SUBMENU_SELECTOR: 'submenu-item-hover',
  SUBMENU_ITEM_SELECTOR: '.js-submenu-item',
  IMAGE_BOX_SELECTOR: '.js-image-box',
  URL_IMAGE_BOX_SELECTOR: '.js-image-box-link'
}

class SubmenuHoverItem extends HTMLElement {
  constructor() {
    super();

    this.submenuItemEls = this.querySelectorAll(selectorsHoverItem.SUBMENU_ITEM_SELECTOR)
  }

  connectedCallback() {
    this.setDefaultLinkImage()

    if (this.submenuItemEls.length > 0) {
      this.submenuItemEls.forEach((item) => {
        item.addEventListener('mouseover', this.showImageBox)
      })
    }
  }

  showImageBox() {
    const linkImage = this.dataset.link_img
    const url = this.dataset.url
    const parent = this.closest(selectorsHoverItem.SUBMENU_SELECTOR)
    const imageBoxEl = parent.querySelector(selectorsHoverItem.IMAGE_BOX_SELECTOR)
    const urlImageBoxEl = parent.querySelector(selectorsHoverItem.URL_IMAGE_BOX_SELECTOR)
    const imageDefault = parent.dataset.defaultImg

    if (linkImage !== '') {
      if (imageBoxEl) {
        imageBoxEl.setAttribute('src', linkImage)
      }

      if (urlImageBoxEl) {
        urlImageBoxEl.setAttribute('href', url)
      }
    } else {
      if (imageBoxEl) {
        imageBoxEl.setAttribute('src', imageDefault)
      }
    }
  }

  setDefaultLinkImage() {
    const urlImageBoxEl = this.querySelector(selectorsHoverItem.URL_IMAGE_BOX_SELECTOR)

    if (urlImageBoxEl) {
      urlImageBoxEl.setAttribute('href', this.submenuItemEls[0].dataset.url)
    }
  }
}

if (!customElements.get("submenu-item-hover")) {
  customElements.define("submenu-item-hover", SubmenuHoverItem);
}